
import Icon from "../../../../public/assets/images/keinternational/true.png"
import { FaPlus } from "react-icons/fa6";
import { FiMinus } from "react-icons/fi";
import React, { useState } from "react";
import { useMediaQuery } from "react-responsive";

const cardsData = [
  {
    icon: "assets/images/keinternational/chat1.png",
    headline: "Recover Abandoned Carts",
    cta:
      "Achieve 20%+ abandoned cart recovery rate with smart, human-like reminders, timed to convert, not annoy.",
  },
  {
    icon: "assets/images/keinternational/chat2.png",
    headline: "Drive CLTV with Repeat Purchases",
    cta:
      "Send cohort based cross-sell, up-sell and restock communication. Send product previews/limited period offers to loyal customer cohorts.",
  },
  {
    icon: "assets/images/keinternational/chat3.png",
    headline: "Automate Returns, Refunds & Exchanges",
    cta:
      "Get pre-built workflows that simplify returns and reduce support queries. Delight customers with seamless experiences.",
  },
  {
    icon: "assets/images/keinternational/chat4.png",
    headline: "Smarter AI Support, Beyond Auto-Replies",
    cta:
      "Deliver instant, human-like responses on WhatsApp 24/7, in 100+languages. Automate 80%+ of queries, boost conversions, and CSAT in every chat.",
  },
];


const cardsData2 = [
  {
    icon: "assets/images/keinternational/shield.svg",
    headline: "GDPR Compliant",
  },
  {
    icon: "assets/images/keinternational/text.svg",
    headline: "Smart, contextual messages only. No cold outreach",
  },
  {
    icon: "assets/images/keinternational/user.svg",
    headline: "<5% opt-out rate across a 165Mn+ shopper network",
  },

];


const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });




export const SectionFour = () => {
const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <div className="section-four-a">
      <div className="container-fluid">
        <div className="heading"  style={{marginLeft:isMobile ? '0.2rem':"6rem"}}>
          <p className="suite-tagline">
            The No-code WhatsApp Engagement Suite
          </p>
          <h1 className="suite-title" style={{ color: "black", fontWeight: "300" }}>
            Turn Every <span className="whatsapp-highlight">WhatsApp chat</span> into a Growth <br />
            Engine and Drive 13X ROI
          </h1>
        </div>
        <div className="feature-grid">
          {cardsData.map((card, idx) => (
            <div className="feature-card" key={idx}>
              <div className="feature-img-container">
                <img src={card.icon} alt={card.headline} className="feature-img" />
              </div>
              <div className="feature-headline">{card.headline}</div>
              <div className="feature-cta">{card.cta}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="section-5a">
        <div className="container-fluid">

          <div className="flex align-items-center sect-5" style={{justifyContent:isMobile?"center":"space-between",gap:"30px",margin:isMobile ? '0 0.2rem':"0 5rem"}}  >
            <div className="mid-text1" style={{ justifyContent: "left" }}>
              <h1 style={{ justifyContent: "left", display: "flex" }}>Go Live in {`<`} 48 Hours </h1>
              <p style={{ justifyContent: "left", display: "flex" }}>No dev time. No tech delays. Just plug and play.</p>
            </div>

            <div>
              <button onClick={scrollToTop} className="cta3">
                Book a Demo
              </button>
            </div>
          </div>
        </div>
      </div>


      <div className="container-fluid">
        <div className="flex flex-wrap align-items-center justify-content-between sect-6 gap-4 md:gap-0" style={{ margin:isMobile ? '30px 0.2rem':"30px 5rem"  }}>

          {/* Text Section */}
          <div className="mid-text2 w-full md:w-6">
            <h1 className="text-left">We Know What Works <br /> on WhatsApp</h1>
            <p className="text-left">Because we have scaled it <br />across 165Mn+ Shoppers globally</p>
          </div>

          {/* Stats Box */}
          <div className="box-1 w-full md:w-5">
            <div className="grid grid-cols-2 gap-4">
              <div style={{ padding: "20px",display:"flex",justifyContent:'center',flexDirection:"column" }}>
                <h2 style={{ color: "#25D366", fontWeight: 300, fontSize: "60px" }}>1.4<span style={{ fontSize: "38px" }}>Bn+</span></h2>
                <p  style={{ fontSize: "20px" }}>Conversations</p>
              </div>
              <div style={{ padding: "20px",display:"flex",justifyContent:'center',flexDirection:"column" }}>
                <h2 style={{ color: "#25D366", fontWeight: 300, fontSize: "60px" }}>15<span style={{ fontSize: "38px" }}>X</span></h2>
                <p  style={{ fontSize: "20px" }}>ROAS</p>
              </div>
              <div style={{ padding: "20px",display:"flex",justifyContent:'center',flexDirection:"column" }}>
                <h2 style={{ color: "#25D366", fontWeight: 300, fontSize: "60px" }}>3<span style={{ fontSize: "38px" }}>X</span></h2>
                <p  style={{ fontSize: "20px" }}>User Engagement</p>
              </div>
              <div style={{ padding: "20px",display:"flex",justifyContent:'center',flexDirection:"column" }}>
                <h2 style={{ color: "#25D366", fontWeight: 300, fontSize: "60px" }}>{`>20%`}</h2>
                <p  style={{ fontSize: "20px" }}>Abandoned Cart Recovery</p>
              </div>
            </div>
          </div>

        </div>







        <div className="mid-text3 w-full md:w-6 mt-10" style={{margin:isMobile ? '0px 0.2rem':"0px 5rem" }}>
          <h1 className="text-left">Built for Privacy. Designed for Trust.</h1>
          <p className="text-left">No one wants spammy messages. That’s why <br /> KwikEngage is consent-first, not push-first.</p>
        </div>

      </div>

      <div className="info-section">
        <div className="card-wrapper">
          {cardsData2.map((card, idx) => (
            <div className="info-card" key={idx}>
              <img src={card.icon} alt="" className="info-icon" />
              <p className="info-text">{card.headline}</p>
            </div>
          ))}
        </div>
      </div>


      <div className="section-6a">
        <div className="container-fluid">
          <div className="testimonial-content">
            <div className="testimonial-text">KwikEngage has been a game changer for us. In just a few months, we saw a <br />134% jump in cart recovery. It’s helped solve key challenges from day one.</div>
            <img
              src="/assets/images/keinternational/true.png"
              alt=""
              className="testimonial-icon"
            />
            <div className="testimonial-headline">Puru Gupta, Co-Founder & CEO</div>
          </div>

        </div>
      </div>


      <div className="testimonial-content">
        <div className="testimonial-text1">Ready to see KwikEngage in Action?</div>

        <div  onClick={scrollToTop}  className="cta4">Book a Demo</div>
      </div>



      <hr style={{ color: '#827A6E' }} />

    </div>



  )
};
